import React from "react";
import ChangeRegionalDatabaseForm from "./ChangeRegionalDatabaseForm";
import BasicModal from "../shared/BasicModal/BasicModal";
import IconLabel from "../shared/IconLabel/IconLabel";
import ModalTitle from "../shared/ModalTitle/ModalTitle";

const ChangeRegionalDatabase = (props) => {
  const onChangeSeoDb = (seoDb) => {
    props.changeSeoDb(props.domain, seoDb);
  };
  return (
    <BasicModal
      openLabel={<IconLabel icon="global" label={`Regional database: ${props.seoDb}`} />}
      modalTitle={<ModalTitle title="Regional database" meta={props.domain} />}
      isPerformingAction={props.isChangingSeoDb}>
      <ChangeRegionalDatabaseForm
        customClassName={"change-tracked-keywords-form"}
        seoDb={props.seoDb}
        onSubmit={(newSeoDb) => onChangeSeoDb(newSeoDb)}
        regionalDatabases={props.regionalDatabases}
        isChangingSeoDb={props.isChangingSeoDb}
      />
    </BasicModal>
  );
};

export default ChangeRegionalDatabase;
